(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-search-form/assets/javascripts/casino-search-form-navigation-button.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-search-form/assets/javascripts/casino-search-form-navigation-button.js');

'use strict';

const {
  ReactButton: Button
} = svs.ui;
const {
  Link
} = ReactRouterDOM;
const CasinoSearchFormNavigationButton = _ref => {
  let {
    link,
    title,
    isActive
  } = _ref;
  return React.createElement(Button, {
    block: true,
    inverted: isActive,
    size: 100,
    transparent: !isActive
  }, React.createElement(Link, {
    to: link
  }, title));
};
setGlobal('svs.components.casino_react.casinoSearchForm.CasinoSearchFormNavigationButton', CasinoSearchFormNavigationButton);

 })(window);